<template>
  <div>
		<table>
			<thead>
				<tr>
					<th>
						<div class="bar bg-blue">
							<h3>Lot number</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Start time</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>End time</h3>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(lot, i) in lots" :key="i">
					<td class="num">{{ lot.num }}</td>
					<td class="start_time">{{ lot.start_time }}</td>
					<td class="end_time">{{ lot.end_time }}</td>
					<td class="icon edit">
						<button class="button-transparent" @click="$emit('edit', lot)">
							<i class="ss-write ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon delete">
						<button v-if="lots.length -1 === i && i > 2" class="button-transparent" @click="$emit('delete', lot)">
							<i class="ss-trash ss-glyphish-filled"></i>
						</button>
					</td>
				</tr>
				<tr v-if="lots.length === 0">
					<td colspan="6">No lots found</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ['lots'],
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Lot/List.vue